// Service API pour les paramètres du site
const BASE_URL = '/api/settings';

async function safeJson(res) {
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) {
    return res.json();
  }
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (_) {
    return { success: false, message: text };
  }
}

export const settingsAPI = {
  // Récupérer tous les paramètres
  getAll: async () => {
    const response = await fetch(BASE_URL);
    const data = await safeJson(response);
    if (!response.ok) {
      const msg = data?.message || data?.error || 'Erreur lors de la récupération des paramètres';
      throw new Error(msg);
    }
    return data;
  },

  // Récupérer un paramètre spécifique
  getByKey: async (key) => {
    const response = await fetch(`${BASE_URL}/${key}`);
    const data = await safeJson(response);
    if (!response.ok) {
      throw new Error(data?.message || 'Paramètre non trouvé');
    }
    return data;
  },

  // Récupérer les paramètres d'une catégorie
  getByCategory: async (category) => {
    const response = await fetch(`${BASE_URL}/category/${category}`);
    const data = await safeJson(response);
    if (!response.ok) {
      throw new Error(data?.message || 'Erreur lors de la récupération des paramètres de la catégorie');
    }
    return data;
  },

  // Récupérer les paramètres d'une section
  getBySection: async (section) => {
    const response = await fetch(`${BASE_URL}/section/${section}`);
    const data = await safeJson(response);
    if (!response.ok) {
      throw new Error(data?.message || 'Erreur lors de la récupération des paramètres de la section');
    }
    return data;
  },

  // Mettre à jour un paramètre
  update: async (key, value, token) => {
    const response = await fetch(`${BASE_URL}/${key}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ setting_value: value })
    });

    const data = await safeJson(response);
    if (!response.ok) {
      throw new Error(data?.message || 'Erreur lors de la mise à jour du paramètre');
    }

    return data;
  },

  // Mettre à jour plusieurs paramètres en lot
  updateBatch: async (settings, token) => {
    const response = await fetch(`${BASE_URL}/batch`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ settings })
    });

    const data = await safeJson(response);
    if (!response.ok) {
      throw new Error(data?.message || 'Erreur lors de la mise à jour des paramètres');
    }

    return data;
  }
};


